import React from 'react'
import toRadian from 'helpers/toRadian'
import { CONVENTIONAL } from 'helpers/globals'
import calculateBoundPoints from '../helpers/calculateBoundPoints'
import calculateClippedView, { computeIntersection } from '../helpers/calculateClippedView'

export default class CameraView extends React.Component {
  componentWillMount() {
    const { showCameraComponents, showAnalyticZones, showCameraBlindspot, horizontalAngleOfView, mapLoaded } = this.props

    if (showCameraComponents && !showAnalyticZones && showCameraBlindspot && horizontalAngleOfView < 180 && mapLoaded) this.drawView(this.props)
  }

  drawView(args) {
    const { verticalAngleOfView, horizontalAngleOfView, map, color, cameraHeight, setCurrentIfApplicable, tilt,
      distance, fovMode, addToMarkers, activeInUI, selectionOverride, showWallBlindspots, walls, cameraMarkerPosition, heading } = args

    const verticalAngle = fovMode === CONVENTIONAL ? verticalAngleOfView : horizontalAngleOfView
    const horizontalAngle = fovMode !== CONVENTIONAL ? verticalAngleOfView : horizontalAngleOfView

    if (this.view) this.view.setMap(null)

    // find angle of bounds
    const closeAngle = 90 + (tilt - verticalAngle)
    const farAngle = closeAngle + verticalAngle

    // find distance to bounds
    const closerBound = Math.tan(toRadian(closeAngle)) * cameraHeight
    const furtherBound = Math.tan(toRadian(farAngle)) * cameraHeight

    // since calculateBoundPoints() returns origin or angleMarker positions if bound is out of range
    if (closerBound > distance || (closerBound < 0 && furtherBound < 0)) {
      if (this.view) this.view.setMap(null)
      else this.view = null
      return
    }

    const closerPaths = calculateBoundPoints({ originAngle: horizontalAngle, bound: closerBound, closer: true, ...args })
    const furtherPaths = calculateBoundPoints({ originAngle: horizontalAngle, bound: furtherBound, closer: false, ...args })
    // order matters
    let paths = [...closerPaths, ...furtherPaths]

    if (showWallBlindspots) {
      const clippedView = calculateClippedView({ walls, angle: horizontalAngle, distance, heading, cameraMarkerPosition, map })
      paths = computeIntersection(paths, clippedView, map)
    }

    this.view = new google.maps.Polygon({
      strokeOpacity: 0,
      fillColor: color,
      fillOpacity: 0.55,
      zIndex: (activeInUI || selectionOverride) ? 104 : 102,
      paths: paths,
      map
    })

    addToMarkers('cameraView', this.view)

    this.view.addListener('click', setCurrentIfApplicable)
  }

  diffProps(nextProps) {
    const keysToCompare = ['tilt', 'horizontalAngleOfView', 'verticalAngleOfView', 'distance', 'heading', 'subjectMarkerDragging',
      'angleMarkerDragging', 'cameraDragging', 'draggingOverride', 'showAnalyticZones', 'showCameraBlindspot', 'ppf', 'color', 'fovMode',
      'showCameraComponents', 'showWallBlindspots', 'walls', 'cameraHeight', 'sceneHeight', 'mapLoaded', 'cameraMarkerPosition']

    return keysToCompare.some(key => {
      return nextProps[key] !== this.props[key]
    })
  }

  componentWillReceiveProps(nextProps) {
    const { subjectMarkerDragging, angleMarkerDragging, cameraDragging, isLens, draggingOverride, showCameraBlindspot,
      horizontalAngleOfView, color, activeInUI, selectionOverride, showAnalyticZones, showCameraComponents } = nextProps

    // if anything is dragging and any dragging state has changed
    if (subjectMarkerDragging ||
      angleMarkerDragging ||
      cameraDragging ||
      (isLens && draggingOverride) ||
      horizontalAngleOfView >= 180 ||
      !showCameraBlindspot ||
      showAnalyticZones ||
      !showCameraComponents) {
        if (this.view) {
          this.view.setMap(null)
          this.view = null
        }
    } else if (!subjectMarkerDragging &&
      !angleMarkerDragging &&
      !cameraDragging &&
      (!isLens || !draggingOverride) &&
      showCameraBlindspot &&
      this.diffProps(nextProps) &&
      horizontalAngleOfView < 180) {
        this.drawView(nextProps)
    }

    if (activeInUI !== this.props.activeInUI || selectionOverride !== this.props.selectionOverride) {
      this.view && this.view.setOptions({ zIndex: (activeInUI || selectionOverride) ? 104 : 102 })
    }

    // change color when switching from active <-> not active
    if (color !== this.props.color && this.view) this.view.setOptions({ fillColor: color })
  }

  shouldComponentUpdate() {
    return false
  }

  render() {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/components/Camera/CameraView/index.js